module.exports = __webpack_public_path__ + "static/img/icon7-7.6c6e6839.png";